import { WorkerShift } from '../../types/auth';
import { format } from 'date-fns';
import { Clock } from 'lucide-react';
import { calculateDuration } from '../../utils/time';
import { useLanguageStore } from '../../store/languageStore';
import translations from '../../translations';

interface RecentShiftsProps {
  shifts: WorkerShift[];
}

export function RecentShifts({ shifts }: RecentShiftsProps) {
  const { language } = useLanguageStore();
  const t = translations[language];

  return (
    <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 border border-light-border dark:border-dark-border shadow-soft dark:shadow-soft-dark">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{t.dashboard.recentActivity.shifts.title}</h2>
      
      {shifts.length === 0 ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">{t.dashboard.recentActivity.shifts.noShifts}</p>
      ) : (
        <div className="space-y-3">
          {shifts.map(shift => {
            const startTime = new Date(shift.clockin_time * 1000);
            const endTime = shift.clockout_time 
              ? new Date(shift.clockout_time * 1000)
              : null;
            
            const duration = endTime 
              ? calculateDuration(shift.clockin_time * 1000, shift.clockout_time! * 1000) 
              : t.dashboard.recentActivity.shifts.inProgress;

            return (
              <div 
                key={shift.clockin_time}
                className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-900/20"
              >
                <div className="bg-primary-50 dark:bg-primary-900/20 rounded-lg p-2">
                  <Clock className="h-4 w-4 text-primary-600 dark:text-primary-400" />
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start">
                    <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                      {format(startTime, 'MMM d, h:mm a')}
                    </p>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      endTime 
                        ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200'
                        : 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200'
                    }`}>
                      {duration}
                    </span>
                  </div>
                  {endTime && (
                    <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                      Ended: {format(endTime, 'h:mm a')}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}